import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SurveyRedirectGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const surveyId = route.params['surveyId'];
    const email = encodeURIComponent(route.params['email']); // Encode for safety
    const redirectUrl = `https://kgate.bc.gov.sa/sa/survey/attempt/${surveyId}?external=1&email=${email}`;

    window.location.href = redirectUrl; // Perform an immediate redirect
    return false; // Prevents Angular from loading anything else
  }
}
